import '~/styles/components/product-card/product-card.scss';

import { Icon } from '@design-system/icon';
import { TraitGroup } from '@design-system/trait-group';
import classNames from 'classnames';
import React, { FC } from 'react';

import { useTranslations } from '~/context/TranslationContext/TranslationsContext';

import { Card } from '../card';
import { BuyNowButton } from './components/buy-now-button';
import { ProductCardProps } from './models';

const BASE_CLASS = 'cds-product-card';

export const ProductCard: FC<ProductCardProps> = ({
  className,
  link,
  variant,
  cardContent,
  cardCta,
  cardMedia,
  cardLabel,
  shopifyBlockComponent,
  categories,
  traitGroup,
  buyNowButton,
  retailers,
  whereToBuyData,
  brandName,
}) => {
  const t = useTranslations();
  const { headingBlock, disclaimer, category } = cardContent;

  const categoryClasses =
    categories?.map((title) => `${BASE_CLASS}--${title}`) || [];

  return (
    <Card
      className={classNames(BASE_CLASS, ...categoryClasses, className)}
      hasMedia={!!cardMedia}
      variant={variant}
    >
      <Card.CardContent
        headingBlock={{ ...headingBlock, headlineLink: link }}
        disclaimer={disclaimer}
        category={category}
        brandName={brandName}
      >
        {traitGroup && <TraitGroup {...traitGroup} />}
        {cardCta && <Card.CardCTA {...cardCta} />}
        {link && (
          <span>
            <a className="product-card__cta" href={link?.props?.href}>
              <span className="product-card__ctaIcon" aria-hidden="true">
                <Icon size={15} icon="arrowRight" />
              </span>
              <span className="product-card__ctaLabel">
                {t?.card?.learnMoreButton}
              </span>
            </a>
          </span>
        )}
        {buyNowButton && (
          <BuyNowButton
            buyNowButton={buyNowButton}
            retailers={retailers}
            whereToBuyData={whereToBuyData}
          />
        )}
        {shopifyBlockComponent}
      </Card.CardContent>
      {cardMedia || cardLabel ? (
        <Card.CardMedia {...cardMedia}>
          {cardLabel && <Card.CardLabel {...cardLabel} />}
        </Card.CardMedia>
      ) : null}
    </Card>
  );
};
